import React from 'react';
import { Icon } from './Icon.js';
export const IconCalendar = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M7 4V2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M17 4V2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 9H21", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 4H21V21H3V4Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconCalendar.js.map